
export const hintColor = "#d06440";

export const appStyles: Record<string, any> = {
    appContainer: {
        backgroundColor: '#091920',
        width: '100vw',          // use 100vw/100vh for most browsers (not 100dvw/100dvh)
        height: '100vh',
        minHeight: '100vh',
        overflow: 'hidden',
        boxSizing: 'border-box',
        // WebkitMaskImage: "linear-gradient(to bottom, #07121c 95%, transparent 100%)",
        // maskImage: "linear-gradient(to bottom, #07121c 95%, transparent 100%)",
    },
    mainContentContainer: {
        width: '100%',
        overflow: 'auto',
        overflowX: 'hidden',
        paddingTop: 1,
        paddingLeft: 2,
        paddingRight: 2,
        textAlign: 'center',
        backgroundImage: 'url(/background.png)',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center top',
        backgroundSize: 'cover', // or 'contain'
    },
    mainContentTitle: {
        fontSize: 14,
        fontWeight: 400,
        color: '#f2f5fa',
        textAlign: "left",
    },
    mainIntelTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: '#02cfee',
        textAlign: "left",
    },
    mainResourceTitle: {
        fontSize: 15,
        fontWeight: 700,
        color: hintColor,
        textAlign: "left",
    },
    secondaryPanelTitleWhite: {
        fontSize: 18,
        fontWeight: 400,
        color: '#f2f5fa',
        textAlign: "center",
    },
    actionPanelTitle: {
        fontSize: 16,
        fontWeight: 400,
        color: '#f2f5fa',
        textAlign: "left",
    },
    actionPinkBorderTopLeft: {
        borderBottom: '1px solid #ff3399',
        height: '45px',
        width: '25px'
    },
    actionPinkBorderTopRight: {
        borderBottom: '1px solid #ff3399',
        borderLeft: '1px solid #ff3399',
        width: 250,
        height: '45px',
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionPinkBorderBottomRight: {
        borderLeft: '1px solid #ff3399',
        width: 250,
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionOrangeBorderTopLeft: {
        borderBottom: '1px solid #d83f2f',
        height: '45px',
        width: '25px'
    },
    actionOrangeBorderTopRight: {
        borderBottom: '1px solid #d83f2f',
        borderLeft: '1px solid #d83f2f',
        width: 160,
        height: '45px',
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionOrangeBorderBottomRight: {
        borderLeft: '1px solid #d83f2f',
        width: 160,
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionGreenBorderTopLeft: {
        borderBottom: '1px solid #38ff82',
        height: '45px',
        width: '25px'
    },
    actionGreenBorderTopRight: {
        borderBottom: '1px solid #38ff82',
        borderLeft: '1px solid #38ff82',
        width: 330,
        height: '45px',
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionGreenBorderBottomRight: {
        borderLeft: '1px solid #38ff82',
        width: 330,
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionBlueBorderTopLeft: {
        borderBottom: '1px solid #02cfee',
        height: '45px',
        width: '25px'
    },
    actionBlueBorderTopRight: {
        borderBottom: '1px solid #02cfee',
        borderLeft: '1px solid #02cfee',
        width: 310,
        height: '45px',
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    actionBlueBorderBottomRight: {
        borderLeft: '1px solid #02cfee',
        width: 310,
        alignItems: 'center',
        justifyItems: 'center',
        paddingLeft: 1,
        spacing: 1
    },
    mainContentHeaderBackground: {
        backgroundColor: '#0f0f0f',
        padding: 1
    },
    primaryLabel: {
        color: '#f2f5fa',
        fontSize: "0.80rem"
    },
    secondaryLabel: {
        color: '#38ff82',
        fontSize: "0.80rem"
    },
    navigationContainer: {
        backgroundColor: '#091920',
        paddingTop: 1,
    },
    defaultPanelContainer: {
        backgroundColor: 'rgba(9, 25, 32, 0.6)', //Same as #091920
        borderRadius: '10px',
        border: '1px solid #7093a0',
        marginTop: '18px',
        marginBottom: '18px',
    },
    defaultPanelCardsWrapper: {
        padding: '5px',
        marginTop: '4px',
        marginBottom: '4px',
        alignItems: 'center',
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
    },
    networkCardsWrapper: {
        padding: '16px',
        marginTop: '4px',
        marginBottom: '4px',
        alignItems: 'center',
        width: "100%",
        boxSizing: "border-box",
        overflowX: "hidden",
    },
    bannerBox: {
        background: `
        linear-gradient(
            to right,
            rgba(41, 53, 64, 0.55), /* #293540 */
            rgba(13, 14, 15, 0.55) /* #0d0e0f */
        )
    `,
        borderRadius: '10px',
        border: '1.5px solid #293540',
        marginTop: '18px',
        marginBottom: '18px',
    },
    resourceLeftNav: {
        margin: '18px',
        color: "#091920",
        fontSize: "0.650rem",
        fontWeight: 600,
        fontFamily: "inherit",
        borderRadius: '10px',
        marginTop: '18px',
        marginBottom: '18px',
        background: `
  /* RIGHT EDGE VIGNETTE (narrow, so top stays white overall) */
    radial-gradient(
      circle at 100% 18%,
      rgba(9, 25, 32, 0.85) 0%,
      rgba(9, 25, 32, 0.55) 14%,
      transparent 26%
    ),

    /* BIG TOP WHITE GLOW (dominant) */
    radial-gradient(
      circle at 75% 8%,
      rgba(255, 255, 255, 0.95) 0%,
      rgba(255, 255, 255, 0.80) 22%,
      rgba(255, 255, 255, 0.40) 45%,
      transparent 68%
    ),

    /* BOTTOM LEFT*/
    radial-gradient(
      circle at 5% 95%,
      #091920 0%,
      rgba(35, 209, 212, 0.5) 20%,
      transparent 80%
    ),

    /* BOTTOM RIGHT*/
    radial-gradient(
      circle at 85% 85%,
      #23d1d4 0%,
      rgba(35, 209, 212, 0.8) 30%,
      transparent 65%
    ),

    /* BASE */
    linear-gradient(
      145deg,
      rgba(13, 14, 15, 0.92),
      rgba(9, 25, 32, 0.96)
    )
  `,
    },
    internalResourceLeftNav: {
        background: `
        linear-gradient(
            to right,
            rgba(41, 53, 64, 0.95), /* #293540 */
            rgba(13, 14, 15, 0.95) /* #0d0e0f */
        )
    `,
        borderRadius: '10px',
        border: '1.5px solid #293540',
        marginTop: '18px',
        marginBottom: '8px',
        marginLeft: '8px',
        marginRight: '8px',
    },

    networkStatNavigation: {
        background: `
        linear-gradient(
            155deg,
            rgba(0, 71, 106, 0.45) 0%, /* #00476a */
            rgba(0, 38, 53, 0.45) 25%, /* #002635 */
            rgba(0, 0, 0, 0.45) 90%, /* #000000 */
            rgba(0, 0, 0, 0.55) 100% /* #000000 */
        )
    `,
        paddingTop: '3px',
        paddingBottom: '7px',
        borderRadius: '10px',
    },
    sectionBox: {
        backgroundColor: 'rgba(9, 25, 32, 0.7)',  /* #091920 */
        borderRadius: '10px',
        border: '1px solid #7093a0',
        padding: '5px',
        marginTop: '10px',
        marginBottom: '10px',
    },
    formHeaderLabel: {
        color: "#38ff82",
        fontWeight: 400,
        fontSize: "1.2rem"
    },
    cardGeneralStyle: {
        backgroundColor: 'rgba(6, 16, 20, 0.5)',  /* #061014 */
        justifyContent: "center",
        borderRadius: "10px",
        border: "0.5px solid #061014",
        padding: "12px",
        cursor: "pointer",
        transition: "box-shadow 0.18s, transform 0.12s",
        "&:hover": {
            transform: "translateY(-2px) scale(1.02)"
        }
    },
    cardGeneralLabel:{
        color: "#eaeaea",
        fontWeight: 500,
        fontSize: "0.85rem"
    },
    cardGeneralKey: {
        color: "#eaeaea",
        fontWeight: 400,
        fontSize: "0.60rem"
    },
    cardGeneralTotal: {
        color: "#38ff82",
        fontWeight: 400,
        fontSize: "0.65rem"
    },
    cardTitleLabel: {
        color: '#f2f5fa',
        fontWeight: 400,
        fontSize: "0.85rem",
        letterSpacing: "0.2px"
    },
    cardDetailText: {
        color: "#38ff82",
        fontWeight: 400,
        fontSize: "0.65rem"
    },
    cardLargeDetailText: {
        color: "#38ff82",
        fontWeight: 400,
        fontSize: "0.80rem"
    },
    cardDetailLabel: {
        color: "#fff",
        fontWeight: 400,
        fontSize: "0.70rem"
    },
    cardNetworkDetails: {
        backgroundColor: "#091920",
        borderRadius: "14px",
        boxShadow: "0 8px 22px 0 rgba(28, 242, 216, 0.13)",
        border: "0.5px solid #00675e",
        padding: "12px",
        width: "180px",
        minHeight: "60px",
        cursor: "pointer",
        transition: "box-shadow 0.18s, transform 0.12s",
        "&:hover": {
            boxShadow: "0 14px 32px 0 rgba(28, 242, 216, 0.18)",
            transform: "translateY(-2px) scale(1.02)"
        }
    },
    cardNetworkNameLabel: {
        color: "#fff",
        fontWeight: 500,
        fontSize: "1.1rem",
        letterSpacing: "0.2px"
    },
    cardNetworkKeyLabel: {
        color: "#02cfee",
        fontWeight: 400,
        fontSize: "0.95rem"
    },
    loginContainer: {
        width: '100vw',
        height: '100vh',
        overflow: 'hidden',
        boxSizing: 'border-box',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        // background: '#00040c',
        backgroundImage: `
        radial-gradient(
            circle at 50% 52%,
            rgba(34,212,253,0.13) 0%,     /* bright cyan highlight */
            rgba(34,212,253,0.08) 18%,    /* still visible */
            rgba(34,212,253,0) 48%        /* fully transparent at edge */
        ),
        radial-gradient(
            circle at 50% 50%,
            rgba(255,255,255,0) 100%,
            rgba(18,25,34,0.98) 100%
        )
    `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    },
    loginOverlay: {
        pointerEvents: 'none',
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        zIndex: 1,
        // This sets up the animated radial gradient:
        background: `radial-gradient(circle at 50% 55%, rgba(34,212,253,0.11) 0%, rgba(34,212,253,0.08) 22%, rgba(34,212,253,0) 60%)`,
    },
    loginImageZone: {
        width: 1000,
        height: 720,
        maxWidth: '96vw',
        maxHeight: '96vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        borderRadius: 10,
        boxShadow: "0 12px 64px 0 rgba(0,0,0,0.30)",
        overflow: "hidden",
        backgroundImage: `
        radial-gradient(
            circle at 50% 50%,
            rgba(255,255,255,0) 62%,
            rgba(18,25,34,0.98) 100%
        ),
        url(/background.png)
    `,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    },
    loginGlass: {
        position: "relative",
        width: 380,
        maxWidth: "90vw",
        minHeight: 350,
        padding: "36px 32px",
        borderRadius: 6,
        boxShadow: "0 10px 42px 0 rgba(0,0,0,0.24)",
        background: "rgba(30, 40, 53, 0.82)", // More solid for legibility
        border: "1.5px solid rgba(28,242,216, 0.32)",
        backdropFilter: "blur(16px) saturate(140%)",
        WebkitBackdropFilter: "blur(16px) saturate(140%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 2,
    },
    buttonStyle: {
        borderRadius: 2,
        boxShadow: "0 10px 42px 0 rgba(0,0,0,0.24)",
        border: "1px solid rgba(0,143,130, 0.8)",
        // border: "0.5px solid rgba(2,207,238, 0.8)",
        // border: "0.5px solid rgba(255,51,153, 0.8)",
        color: '#02cfee',
        fontSize: 12
    },
    toggleButtonStyle: {
        backgroundColor: 'rgba(9, 25, 32, 0.6)', //Same as #091920
        padding: 0,
        borderBottom: '3px solid #02cfee',
    },
    filterBox: {
        backgroundColor: 'rgba(9, 25, 32, 0.6)', //Same as #091920
        padding: 0,
        border: '1px solid #7093a0',
    },
    showCountText: {
        fontSize: 12,
        fontWeight: 400,
        color: '#38ff82',
        textAlign: "center",
    },
    cardContainer: {
        backgroundColor: 'rgba(15, 15, 15, 0.6)', //Same as #0f0f0f
        border: `1px solid ${hintColor}`,
    },
    alphaNumberFilterLeftRail: {
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        border: "1px solid #7093a0",
        borderRadius: "10px",
        padding: "6px",
        boxSizing: "border-box",

        // left rail holds two bars side-by-side
        minWidth: "260px", // 2 * 130
        width: "fit-content", // allow to grow if counts are wide
    },

    alphaNumberFilterAlphaRailRow: {
        width: "100%",
        alignItems: "flex-start",
    },

    alphaNumberRightRail: {
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        border: "1px solid #7093a0",
        borderRadius: "10px",
        padding: "6px",
        width: "fit-content",
        minWidth: "130px",
        boxSizing: "border-box",
    },

    alphaNumberToggleGroupVertical: {
        padding: 0,
        minWidth: "130px",
        width: "fit-content",

        "& .MuiToggleButtonGroup-grouped": {
            margin: 0,
            border: 0,
            borderRadius: 0,
        },
        "& .MuiToggleButtonGroup-firstButton": {
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
        },
        "& .MuiToggleButtonGroup-lastButton": {
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
        },
    },

    alphaNumberToggleButton: {
        width: "100%",
        border: 0,
        textTransform: "none",
        padding: "6px 6px",
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        color: "#f2f5fa",

        borderRight: "3px solid #02cfee",

        "&:not(:last-of-type)": {
            borderBottom: "1px solid rgba(112, 147, 160, 0.25)",
        },

        "& .rv-pill": {
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "10px",

            padding: "2px 8px",
            borderRadius: "999px",

            backgroundColor: "rgba(9, 25, 32, 0.35)",
        },

        "& .rv-label": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: 12,
        },

        "& .rv-count": {
            whiteSpace: "nowrap",
            fontSize: 12,
            fontWeight: 400,
            color: "#38ff82",
            opacity: 0.95,
        },

        "&.Mui-selected": {
            backgroundColor: "rgba(2, 207, 238, 0.10)",
            borderRight: "3px solid #38ff82",

            "& .rv-pill": {
                backgroundColor: "rgba(9, 25, 32, 0.68)",
                boxShadow: "0 0 0 1px rgba(56, 255, 130, 0.35)",
            },

            "& .rv-label": {
                color: "#f2f5fa",
                opacity: 1,
            },
            "& .rv-count": {
                color: "#f2f5fa",
                opacity: 1,
            },
        },

        "&.Mui-selected:hover": {
            backgroundColor: "rgba(2, 207, 238, 0.14)",
        },
    },

    alphaNumberToggleLabel: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },

    alphaNumberToggleCount: {
        whiteSpace: "nowrap",
        fontSize: "12px",
        fontWeight: 400,
        color: "#38ff82",
        opacity: 0.9,
    },

    alphaNumberCenter: {
        flexGrow: 1,
        minWidth: 0, // IMPORTANT for responsive 3-column layout
    },

    alphaNumberResultsPanel: {
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        border: "1px solid #7093a0",
        borderRadius: "10px",
        padding: "10px",
        width: "100%",
        height: "100%",
        minHeight: "520px",
        boxSizing: "border-box",
        alignItems: "center",
    },
    alphaNumberFilterRow: {
        width: "350px",
        alignItems: "center",
    },

    alphaNumberFilterField: {
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        borderRadius: "10px",
        "& .MuiOutlinedInput-root": {
            borderRadius: "10px",
            color: "#f2f5fa",

            "& fieldset": {
                border: "1px solid #7093a0",
            },
            "&:hover fieldset": {
                border: "1px solid #02cfee",
            },
            "&.Mui-focused fieldset": {
                border: "1px solid #02cfee",
            },
        },

        "& input::placeholder": {
            color: "rgba(242, 245, 250, 0.55)",
            opacity: 1,
        },
    },

    alphaNumberFilterCount: {
        fontSize: 12,
        fontWeight: 400,
        color: "#38ff82",
        textAlign: "left",
        paddingLeft: "2px",
    },
    alphaNumberFooterContainer: {
        marginTop: "6px",
        paddingTop: "6px",
        borderTop: "1px solid rgba(112, 147, 160, 0.28)",
        boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.35)",
    },

    alphaNumberToggleGroupSpan: {
        padding: 0,
        width: "100%",
        minWidth: "260px", // 2 * 130
        "& .MuiToggleButtonGroup-grouped": {
            margin: 0,
            border: 0,
            borderRadius: 0,
        },
        "& .MuiToggleButtonGroup-firstButton": {
            borderRadius: "8px",
        },
        "& .MuiToggleButtonGroup-lastButton": {
            borderRadius: "8px",
        },
    },

    alphaNumberToggleButtonSpan: {
        width: "100%",
        minWidth: "260px",
    },

    alphaNumberToggleButtonFooter: {
        backgroundColor: "rgba(9, 25, 32, 0.75)",

        "& .rv-pill": {
            backgroundColor: "rgba(9, 25, 32, 0.50)",
            boxShadow: "none",
        },

        "&.Mui-selected .rv-pill": {
            boxShadow: "inset 0 0 0 1px rgba(112, 147, 160, 0.22)",
        },
    },
    defaultHorizontalDivider: {
        width: "100%",
        paddingTop: "5px",
        marginBottom: "5px",
        borderBottom: "1px solid rgba(112, 147, 160, 0.28)",
        boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.35)",
    },
    alphaNumberDatasetSearchDivider: {
        width: "100%",
        paddingTop: "5px",
        marginBottom: "5px",
        borderBottom: "1px solid rgba(112, 147, 160, 0.28)",
        boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.35)",
    },
    leftNavInner: {
        width: "100%",
        maxWidth: "310px",
        marginLeft: "auto",
        marginRight: "auto",
        boxSizing: "border-box",
        paddingLeft: "16px",
        paddingRight: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
    },

    leftNavList: {
        width: "100%",
        marginTop: "6px",
        textAlign: "left",
        "& .MuiListSubheader-root": {
            textAlign: "left",
        },
        "& .MuiListItemText-root": {
            textAlign: "left",
        },
    },

    leftNavSectionHeader: {
        color: "#02cfee",
        background: "transparent",
        fontSize: "14px",
        fontWeight: 700,
        letterSpacing: "0.6px",
        lineHeight: "30px",

        width: "100%",
        display: "block",
        boxSizing: "border-box",

        paddingLeft: "6px",
        paddingRight: "6px",

        textAlign: "left",
        marginTop: "8px",

        borderTop: "1px solid rgba(112, 147, 160, 0.28)",
    },

    leftNavItemIcon: {
        minWidth: "34px",
        color: "rgba(242, 245, 250, 0.75)",
    },

    leftNavItem: {
        borderRadius: "10px",
        margin: "4px 0",
        paddingTop: "2px",
        paddingBottom: "2px",
        paddingLeft: "6px",
        paddingRight: "6px",
        position: "relative",
        overflow: "hidden",
        whiteSpace: "nowrap",

        "--navAccent": "rgba(2, 207, 238, 0.85)",
        "--navAccentSoft": "rgba(2, 207, 238, 0.15)",
        "--navAccentBg": "rgba(2, 207, 238, 0.06)",

        color: "rgba(242, 245, 250, 0.90)",

        "&:hover": {
            outline: "1px solid var(--navAccent)",
            background: "rgba(16, 27, 28, 0.55)",
        },

        "& .MuiListItemText-root": {
            overflow: "hidden",
        },

        "& .MuiListItemText-primary": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "11px",
        },
        "&.Mui-focusVisible": {
            outline: "1px solid var(--navAccent)",
            outlineOffset: "2px",
            boxShadow: "0 0 0 3px var(--navAccentSoft)",
            background: "var(--navAccentBg)",
        },

        '&[aria-current="page"]': {
            outline: "1px solid var(--navAccent)",
            background: "linear-gradient(135deg, #101b1c 0%, #090d16 100%)",
        },

        '&[aria-current="page"].Mui-focusVisible': {
            outline: "2px solid var(--navAccent)",
            outlineOffset: "2px",
            boxShadow: "0 0 0 3px var(--navAccentSoft)",
        },

        '&[aria-current="page"]::before': {
            content: '""',
            position: "absolute",
            left: 0,
            top: 0,
            bottom: 0,
            width: "4px",
            backgroundColor: "var(--navAccent)",
        },

        '&[aria-current="page"] .MuiListItemIcon-root': {
            color: "rgba(255,255,255,0.95)",
        },
    },
    leftNavItemTeal: {
        "--navAccent": "rgba(2, 207, 238, 0.85)",
        "--navAccentSoft": "rgba(2, 207, 238, 0.15)",
        "--navAccentBg": "rgba(2, 207, 238, 0.06)",
    },

    leftNavItemPink: {
        "--navAccent": "rgba(208, 100, 64, 0.85)",
        "--navAccentSoft": "rgba(208, 100, 64, 0.15)",
        "--navAccentBg": "rgba(208, 100, 64, 0.06)",
    },

    panelSectionTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: "#FFFFFF",
        textAlign: "center",
    },

    panelFilterInput: {
        background: "rgba(15, 15, 15, 0.25)",
        border: "1px solid #3F464F",
        borderRadius: "10px",
        width: "300px",
        "& .MuiInputBase-input": {
            color: "#F2F5FA",
            fontSize: "12px",
            padding: "6px 12px",
        },
        "& .MuiInputBase-input::placeholder": {
            color: "#7093a0",
            opacity: 1,
        },
    },

    panelFilterCount: {
        fontSize: 12,
        fontWeight: 700,
        color: "#38ff82",
        paddingLeft: "10px",
        whiteSpace: "nowrap",
    },

    panelActionButton: {
        fontSize: "0.70rem",
        whiteSpace: "nowrap",
        minWidth: "120px",
    },

    leftNavItemCount: {
        fontSize: "11px",
        fontWeight: 600,
        color: "#38ff82",
        minWidth: "28px",
        textAlign: "right",
        lineHeight: 1,
        flexShrink: 0,
        marginLeft: "auto",
    },

    leftNavGraphButton: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "10px",
        border: "1px solid rgba(2, 207, 238, 0.4)",
        background: "rgba(2, 207, 238, 0.06)",
        color: "rgba(242, 245, 250, 0.90)",
        padding: "6px 16px",
        marginTop: "10px",
        cursor: "pointer",
        fontSize: "12px",
        fontWeight: 600,
        letterSpacing: "0.5px",
        transition: "all 0.2s ease",
        "&:hover": {
            outline: "1px solid rgba(2, 207, 238, 0.85)",
            background: "rgba(2, 207, 238, 0.12)",
        },
    },

    panelIconButton: {
        borderRadius: "8px",
        border: "1px solid #7093a0",
        backgroundColor: "rgba(9, 25, 32, 0.6)",
        color: "#F2F5FA",
        transition: "all 0.2s ease",
        "&:hover": {
            backgroundColor: "rgba(2, 207, 238, 0.12)",
            borderColor: "rgba(2, 207, 238, 0.85)",
        },
        "&:active": {
            backgroundColor: "rgba(2, 207, 238, 0.25)",
        },
    },

// ***************************Reference - not implemented
//     navToggleButton: {
//         justifyContent: 'center',
//         paddingTop: 1,
//         paddingBottom: 1,
//         paddingRight: 1,
//         borderRadius: 0,
//         width: '100%',
//         border: 'none',
//         '&.Mui-selected': {
//             background: 'linear-gradient(to right, #101b1c, #090d16)',
//             borderLeft: '4px solid #02CFEE',
//             color: '#FFFFFF',
//         },
//         '&.Mui-selected:hover': {
//             background: 'linear-gradient(to right, #101b1c, #00040c)',
//             borderLeft: '4px solid #02CFEE',
//         },
//         '&:hover': {
//             background: 'linear-gradient(to right, #090d16, #02CFEE)',
//             // backgroundColor: '#1c1c1c',
//         },
//         '&.Mui-focusVisible': {
//             outline: 'none',
//             boxShadow: 'none',
//         },
//         '&.Mui-selected.Mui-focusVisible': {
//             outline: 'none',
//             boxShadow: 'none',
//         },
//     },
//

//     chartTitle: {
//         fontSize: 20,
//         fontWeight: 700,
//         color: "#b6bfce"
//     },
//     chartAxis: {
//         fontSize: 14,
//         color: "#424242"
//     },
//     chartBar: {
//         color: "#02CFEE"
//     },
//     sectionInnerBox: {
//         backgroundColor: '#091920',
//         borderRadius: '12px',
//         border: '1.5px solid #1f2228',
//         boxSizing: 'border-box',
//         p: 2,
//     },
//     sectionTitle: {
//         fontSize: '16px',
//         fontWeight: 500,
//         letterSpacing: '0.5px',
//         color: '#38ff82',
//         marginBottom: '12px',
//         textAlign: 'left',      // Enforces left alignment
//         paddingLeft: 0,         // Ensure no side padding interferes
//         paddingRight: 0,
//     },
//     sectionLabel: {
//         color: '#FFFFFF',
//         fontSize: '11px',
//     },
//     headerNetworkLabel: {
//         backgroundColor: '#02CFEE',
//         color: '#000',
//         padding: '4px',
//         border: "2px solid #1f2228",
//         borderRadius: "12px",
//         boxShadow: "none",
//     },
//     mapCollectionsCard: {
//         backgroundColor: '#091920',
//         border: "2px solid #1f2228",
//         borderRadius: "12px",
//         boxShadow: "none",
//         transition: "border-color 0.2s, background 0.2s",
//         "&:hover": {
//             borderColor: "#02CFEE", // highlight on hover
//             backgroundColor: "#091920", // same as container, no color shift
//         },
//     },
//     mapCollectionsCardNoNavigation: {
//         backgroundColor: '#091920',
//         border: "2px solid #1f2228",
//         borderRadius: "12px",
//         boxShadow: "none",
//         transition: "border-color 0.2s, background 0.2s",
//     },
//     mapTrackLeftList: {
//         flex: 1,
//         width: "100%",
//         background: "transparent",
//         overflowY: "auto",
//         maxHeight: "350px",
//         overflow: 'auto',
//         overflowX: 'hidden',
//         paddingRight: 1
//     },
//     internalPanel: {
//         background: "#091920",
//         border: "1px solid #1f2228",
//         borderRadius: 2,
//         padding: "16px",
//         width: "100%",
//         boxSizing: "border-box",
//         marginBottom: "0px",
//     },
//     cardTrackDetails: {
//         backgroundColor: "#091920",
//         borderRadius: "14px",
//         boxShadow: "0 8px 22px 0 rgba(28, 242, 216, 0.13)",
//         border: "0.5px solid #424242",
//         padding: "12px",
//         minHeight: "60px",
//         cursor: "pointer",
//         transition: "box-shadow 0.18s, transform 0.12s",
//         "&:hover": {
//             boxShadow: "0 14px 32px 0 rgba(28, 242, 216, 0.18)",
//             transform: "translateY(-2px) scale(1.02)"
//         },
//     },
//     popupBox: {
//         borderRadius: 2,
//         boxShadow: "0 8px 32px rgba(0,0,0,0.22)",
//         background: "#181e27",
//     },
//     formBoxStyle: {
//         minWidth: 420,
//         maxWidth: 540,
//         borderRadius: 8,
//         boxShadow: "0 6px 24px 0 rgba(0,0,0,0.72)",
//         p: 5,
//         m: 2,
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "rgba(18, 25, 34, 0.98)", // more opaque, richer
//         border: "1px solid #232b39",
//     },
//     compAlertNotification: {
//         base: {
//             width: '100%',
//             borderRadius: 2,
//             borderWidth: '0.5px',
//             borderStyle: 'solid',
//             boxShadow: 3,
//             fontWeight: 500,
//             alignItems: 'center',
//             display: 'flex',
//             gap: 1,
//             py: 2,
//             px: 3,
//             minHeight: '48px',
//             fontSize: '1.1rem',
//         },
//         success: {
//             backgroundColor: 'rgba(0, 103, 93, 0.4)', // #00675d at 40%
//             borderColor: '#02CFEE',
//             color: '#fff',
//         },
//         error: {
//             backgroundColor: 'rgba(255, 94, 58, 0.4)', // #ff5e3a at 40%
//             borderColor: '#d83f2f',
//             color: '#fff',
//         },
//     },
//
// **********************************************************
}